import { render, staticRenderFns } from "./InfoIcon.vue?vue&type=template&id=6c5f2494&scoped=true&"
import script from "./InfoIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./InfoIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5f2494",
  null
  
)

export default component.exports